import { FieldHookConfig } from 'formik'
import React from 'react'
import { Cell, Grid } from 'react-foundation'
import { ServiceRequestMember } from '../../../models'
import { displayDate } from '../../../utilities'
import { ApiFetch } from '../Api'
import { AsyncSelectField } from '../AsyncSelectField'

const formatOption = (data: { member: ServiceRequestMember, value: string }, ref: { context: string }) => <>
    {ref.context !== 'menu' && <div>{data.member?.name}</div>}
    {ref.context === 'menu' && <Grid>
        <Cell large={5} small={12}>
            {data.member?.name}
        </Cell>
        <Cell large={4} small={7} className='select-sub-data'>
            {data.member?.medicaidID && <><strong>Medicaid ID:</strong> {data.member?.medicaidID}</>}
            {!(data.member?.medicaidID) && <><strong>CareSource ID:</strong> {data.member?.memberID}</>}
        </Cell>
        {data.member.birthDate && <Cell large={3} small={5} className='select-sub-data'>
            <strong>DOB:</strong> {displayDate(data.member.birthDate)}
        </Cell>}
    </Grid>}
</>

const MemberSearchSelect: React.FC<FieldHookConfig<string>> = (props) => {
    let searchTimeoutRef: NodeJS.Timeout | null = null
    const searchMember = (inputValue: string) => {
        return new Promise<{ member: ServiceRequestMember, value: string }[]>(resolve => {
            if(inputValue.length < 3) {
                resolve([])
                return
            }
            if(searchTimeoutRef) clearTimeout(searchTimeoutRef)
            searchTimeoutRef = setTimeout(() => {
                resolve(
                    ApiFetch<ServiceRequestMember[]>('Member/ServiceRequest', { search: inputValue })
                        .then(result => result.map((r) => {
                            return {
                                value: r.serviceRequestMemberID?.toString() || '',
                                member: r
                            }
                        }))
                )
            }, 600)
        })
    }
    return <AsyncSelectField
        {...props}
        formatOptionLabel={formatOption}
        loadOptions={searchMember}
        noOptionsMessage={(field: {inputValue: string})=><>
            {field.inputValue && field.inputValue.length >= 3 ? 'No results found' : 'Enter ID or name to begin search'}
        </>} />
}

export default MemberSearchSelect